import script from "./LandingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./LandingPage.vue?vue&type=script&setup=true&lang=js"

import "./LandingPage.vue?vue&type=style&index=0&id=2e58438d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e58438d"]])

export default __exports__